import Vue from 'vue';
import moment from 'moment';

/**
 * aplica a máscara 000.000.000-00 em cpf
 * @param {string} cpf alvo
 */
export function formatCPF(cpf) {
    cpf = onlyNumbers(cpf).substr(0, 11);
    return cpf.replace(/(.{3})(.{3})(.{3})(.{2})/g, "$1.$2.$3-$4");
}

/**
 * aplica a máscara 00.000.000/0000-00 em cnpj
 * @param {string} cnpj cnpj
 */
export function formatCNPJ(cnpj) {
    cnpj = onlyNumbers(cnpj).substr(0, 14);
    return cnpj.replace(/(.{2})(.{3})(.{3})(.{4})(.{2})/g, "$1.$2.$3/$4-$5");
}

/**
 * remove tudo que não número
 * @param {string} str alvo
 */
export function onlyNumbers(str) {
    return String(str).replace(/[^0-9]+/g, "");
}

export const formatDate = Vue.filter('formatDate', function (value, hours = true) {
    if (value) {

        moment.locale('pt-BR');

        if (hours) {
            return moment(String(value)).format('DD/MM/YYYY HH:mm:ss');
        }

        return moment(String(value)).format('DD/MM/YYYY');
    }

    return null;
});

export const formatDateToUs = Vue.filter('formatDate', function (value, convert = false) {
    if (value) {

        moment.locale('pt-BR');

        if (convert) {
            value = value.split("/").reverse().join("-");
        }

        return moment(String(value)).format('YYYY-MM-DD');
    }

    return null;
});


export const isNumeric = (value) => {
    var regra = /^[0-9]+$/;

    if (String(value).match(regra)) {
        return true;
    }

    return false;
}

export const formatValueToOnlyNumber = (value) => {

    value = String(value);

    value = value.replace(",", "");
    value = value.replace(".", "");
    value = value.replace(".", "");
    value = value.replace(".", "");

    return value;

}

export const formatValueToPercentage = (value) => {

    value = String(value);

    value = value.replace(",", ".");

    return value;

}

export const formatValueOnKeyUp = (value) => {

    value = value.replace(".", "");
    value = value.replace(".", "");
    value = value.replace(".", "");
    value = value.replace(",", "");

    if (!isNumeric(value)) {
        return "0,00";
    }

    return formatPrice(value);
}

export const formatPrice = (value) => {
    // var _value = (value / 100).toLocaleString("pt-BR", {
    //     style: "currency",
    //     currency: "BRL"
    // });

    // _value = _value.replace(" ", "");
    // _value = _value.replace(" ", "");
    // _value = _value.replace("R$", "");
    // _value = _value.replace(" ", "");
    // _value = _value.replace(" ", "");
    // _value = _value.trim();

    // return _value;
    if (value) {
        let val = (value / 100).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    }

    return 0;

}

export const formatCurrency = (value) => {
    if (value == null || value === '') return '0,00';

    let cleanValue;
    if (typeof value === 'string') {
        if (value.includes(',')) {
            cleanValue = value.replace(/\./g, '').replace(',', '.');
        } else {
            cleanValue = value.replace(/[^\d.-]/g, '');
        }
    } else {
        cleanValue = value;
    }

    const num = parseFloat(cleanValue);

    if (isNaN(num)) return '0,00';

    return num
        .toFixed(2)
        .replace('.', ',')
        .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
}

export const addDaysToDate = (days) => {
    var today = new Date();
    var date = new Date(today.getTime() + (days * 24 * 60 * 60 * 1000));

    var day = date.getDate();
    var month = date.getMonth() + 1;
    var year = date.getFullYear();

    if (parseInt(day) < 10) {
        day = `0${day}`;
    }

    if (parseInt(month) < 10) {
        month = `0${month}`;
    }

    return `${year}-${month}-${day}`;
}